import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { AxiosApi } from "../../helpers/AxiosApi";
import initialStates from "./state";

// Get Sales
export const getSales = createAsyncThunk(
  "getSales",
  async (
    {
      search,
      type,
      status,
      start_range,
      end_range,
      sort_by,
      sort_direction,
      pageCount,
      pageLimit,
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await AxiosApi.get(
        `sales?search=${search}&status=${status}&type=${type}&start_range=${start_range}&end_range=${end_range}&sort_by=${sort_by}&sort_direction=${sort_direction}&page=${pageCount}&limit=${pageLimit}`
      );
      return response.data.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Update Sale Status
export const updateSaleStatus = createAsyncThunk(
  "updateSaleStatus",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.put(`sales/update-status/${id}`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Create Update Sale
export const createUpdateSale = createAsyncThunk(
  "createUpdateSale",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`sales`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Delete Sale
export const deleteSales = createAsyncThunk(
  "deleteSales",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(`sales/${id}`);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// refund billing transactions Sale
export const refundBillingTransactions = createAsyncThunk(
  "refundBillingTransactions",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.put(`refund-billing-transactions/${id}`);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Add Update Sale Remarks
export const addUpdateSaleRemarks = createAsyncThunk(
  "addUpdateSaleRemarks",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`sale-remarks`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Delete Sale Remarks
export const deleteSaleRemarks = createAsyncThunk(
  "deleteSaleRemarks",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(`sale-remarks/${id}`);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Get Sale By ID
export const getSaleById = createAsyncThunk(
  "getSaleById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(`sale-remarks/${id}`);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// get billing transactions Details
export const getBillingTransactionsDetails = createAsyncThunk(
  "getBillingTransactionsDetails",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(`billing-transactions/${id}`);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// get company subscription Details
export const getCompanySubscriptionDetails = createAsyncThunk(
  "getCompanySubscriptionDetails",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(`company-subscription/${id}`);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Edit Company Subscription
export const editCompanySubscription = createAsyncThunk(
  "editCompanySubscription",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`sales`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

const salesSlice = createSlice({
  name: "sales",
  initialState: initialStates,
  extraReducers: (builder) => {
    builder
      // get Sales
      .addCase(getSales.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSales.fulfilled, (state, action) => {
        state.loading = false;
        state.getSalesStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getSales.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Update Sale Status
      .addCase(updateSaleStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateSaleStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.updateSaleStatusStatus.data = action.payload;
        state.error = false;
      })
      .addCase(updateSaleStatus.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // create Update Sale
      .addCase(createUpdateSale.pending, (state) => {
        state.loading = true;
      })
      .addCase(createUpdateSale.fulfilled, (state, action) => {
        state.loading = false;
        state.createUpdateSaleStatus.data = action.payload;
        state.error = false;
      })
      .addCase(createUpdateSale.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Delete Sale
      .addCase(deleteSales.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteSales.fulfilled, (state, action) => {
        state.loading = false;
        state.deleteSalesStatus.data = action.payload;
        state.error = false;
      })
      .addCase(deleteSales.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Refund Billing Transactions Sale
      .addCase(refundBillingTransactions.pending, (state) => {
        state.loading = true;
      })
      .addCase(refundBillingTransactions.fulfilled, (state, action) => {
        state.loading = false;
        state.refundBillingTransactionsStatus.data = action.payload;
        state.error = false;
      })
      .addCase(refundBillingTransactions.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // add Update Sale Remarks
      .addCase(addUpdateSaleRemarks.pending, (state) => {
        state.loading = true;
      })
      .addCase(addUpdateSaleRemarks.fulfilled, (state, action) => {
        state.loading = false;
        state.addUpdateSaleRemarksStatus.data = action.payload;
        state.error = false;
      })
      .addCase(addUpdateSaleRemarks.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // delete Sale Remarks
      .addCase(deleteSaleRemarks.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteSaleRemarks.fulfilled, (state, action) => {
        state.loading = false;
        state.deleteSaleRemarksStatus.data = action.payload;
        state.error = false;
      })
      .addCase(deleteSaleRemarks.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Get Sale by ID
      .addCase(getSaleById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSaleById.fulfilled, (state, action) => {
        state.loading = false;
        state.getSaleByIdStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getSaleById.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Edit Company Subscription
      .addCase(editCompanySubscription.pending, (state) => {
        state.loading = true;
      })
      .addCase(editCompanySubscription.fulfilled, (state, action) => {
        state.loading = false;
        state.editCompanySubscriptionStatus.data = action.payload;
        state.error = false;
      })
      .addCase(editCompanySubscription.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // get Company Subscription Details
      .addCase(getCompanySubscriptionDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCompanySubscriptionDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.getCompanySubscriptionDetailsStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getCompanySubscriptionDetails.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // get Billing Transactions Details
      .addCase(getBillingTransactionsDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBillingTransactionsDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.getBillingTransactionsDetailsStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getBillingTransactionsDetails.rejected, (state) => {
        state.loading = false;
        state.error = true;
      });
  },
});
const { reducer } = salesSlice;
export default reducer;
